export enum AutoPayStatus {
  NotFilled,
  PendingSignature,
  TurnedOn,
  TurnedOff,
}
